import { render, staticRenderFns } from "./LazyVImg.vue?vue&type=template&id=6af5a4ef&scoped=true"
import script from "./LazyVImg.vue?vue&type=script&lang=js"
export * from "./LazyVImg.vue?vue&type=script&lang=js"
import style0 from "./LazyVImg.vue?vue&type=style&index=0&id=6af5a4ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af5a4ef",
  null
  
)

export default component.exports